import { Box } from '@fhs-legacy/universal-components';
import { theme } from 'styles/configure-theme';

export const StoreCardListContainer = Box.withConfig({
  width: 'full',
  flex: 1,
  backgroundColor: theme.token('background-default'),
});
